module.exports = __webpack_public_path__ + "static/media/prodomus.021dcbeb.png";